export const EmplDetailHistorySxStyles = () => {
  return {
    dialogClose: {
      float: 'right',
      color: '#05A4D8',
      paddingTop: '0px',
      paddingRight: '4px',
    },
    tableHeader: {
      fontSize: '16px',
      textAlign: 'left',
      tableLayout: 'fixed',
      width: '100%',
    },
  };
};
